/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SquareApiProxyRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {SquareApiProxyResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const squareApiProxy = (request:SquareApiProxyRequest, options?: CashRequestOptions) => post<SquareApiProxyRequest, SquareApiProxyResponse>("/2.0/cash/square-api-proxy", request, {...options, rejectOnError: true })